import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */
  getAll(params) {
    return backofficeService.Api().get('api/leads/all', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get category by id
   * @param {*} params Query Options
   */
  getById(id, params) {
    return backofficeService.Api().get(`api/leads/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  convertedStores(id, params) {
    return backofficeService.Api().get(`api/leads/convertedStores/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  leadStore() {
    return backofficeService.Api().get('crm/api/store/leadStore')
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  searchInLeads(params = {}) {
    return backofficeService.Api().get('api/leads/all', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  create(data) {
    return backofficeService.Api().post('api/leads', data)
      .then(response => {
        console.log('response', response)
        return response.data
      })
      .catch((error) => { throw error })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    console.log('data in update is :', data)
    return backofficeService.Api().put(`api/leads/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  unConvertLead(id, data) {
    return backofficeService.Api().put(`api/unConvertLead/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  convertLead(id, data) {
    return backofficeService.Api().put(`api/convertLead/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  removeAllConvertedStores(id) {
    return backofficeService.Api().put(`api/removeAllConvertedStores/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete category
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`api/leads/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
